// /src/js/locales/es.js
export default {
  // Core common actions and states
  common: {
    // Actions
    save: "Guardar",
    logout: "Cerrar sesión",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    add: "Agregar",
    create: "Crear",
    update: "Actualizar",
    close: "Cerrar",
    change: "Cambiar",

    // States
    loading: "Cargando...",
    active: "Activo",
    inactive: "Inactivo",
    retry: "Reintentar",
    // Messages
    error: "Error",
    success: "Éxito",
    warning: "Advertencia",

    // Common UI
    actions: "Acciones",
    search: "Buscar",
    all: "Todos",
    optional: "opcional",
    characters: "caracteres",
  },

  // Global common translations
  global: {
    cancel: "Cancelar",
    save: "Guardar",
    delete: "Eliminar",
    edit: "Editar",
    add: "Agregar",
    close: "Cerrar",
    change: "Cambiar",
    saving: "Guardando...",
    hide: "Ocultar",
    showPreview: "Ver vista previa",
  },

  // Form-related translations
  form: {
    name: "Nombre",
    description: "Descripción",
    duration: "Duración",
    price: "Precio",
    currency: "Moneda",
    category: "Categoría",
    service: "Servicio",
    icon: "Icono",
    color: "Color",
    phone: "Teléfono",
    email: "Correo Electrónico",
    address: "Dirección",
    role: "Rol",
    // Validation
    required: "Este campo es obligatorio",
    invalidPhone: "Número de teléfono inválido",
    invalidEmail: "Correo electrónico inválido",
    positive: "El valor debe ser mayor que 0",
  },

  // Business/Salon related
  salon: {
    name: "Nombre del Salón",
    description: "Descripción del Salón",
    services: "Servicios",
    categories: "Categorías",
    serviceCategories: "Categorías de Servicios",
    professionals: "Profesionales",
    businessHours: "Horario de Atención",
    contact: "Información de Contacto",
  },

  // Services management (admin)
  services: {
    title: "Servicios del Salón",
    subtitle: "Administra los servicios y categorías de tu salón",
    allServices: "Todos los Servicios",
    searchPlaceholder: "Buscar servicios...",

    // Dialogs
    addService: "Agregar Nuevo Servicio",
    editService: "Editar Servicio",
    addCategory: "Agregar Nueva Categoría",
    editCategory: "Editar Categoría",

    // Table headers
    tableHeaders: {
      service: "Servicio",
      category: "Categoría",
      duration: "Duración",
      price: "Precio",
      active: "Activo",
      actions: "Acciones",
    },

    // Form labels
    serviceName: "Nombre del Servicio",
    serviceDescription: "Descripción del Servicio",
    serviceDuration: "Duración (minutos)",
    servicePrice: "Precio",
    categoryName: "Nombre de la Categoría",
    categoryDescription: "Descripción de la Categoría",

    // Placeholders
    serviceNamePlaceholder: "Corte de Mujer",
    categoryPlaceholder:
      "ej., Servicios de Cabello, Cuidado de Uñas, Cuidado de la Piel",
    descriptionPlaceholder: "Breve descripción de esta categoría",

    // Options
    currencies: {
      usd: "USD ($)",
      eur: "EUR (€)",
      gbp: "GBP (£)",
      mxn: "MXN ($)",
    },

    icons: {
      scissors: "Tijeras",
      hand: "Mano",
      face: "Rostro",
      brush: "Pincel",
      spa: "Spa",
    },

    colors: {
      red: "Rojo",
      blue: "Azul",
      green: "Verde",
      orange: "Naranja",
      teal: "Verde Azulado",
      purple: "Morado",
    },
  },

  syncStatus: {
    title: "Estado de Sincronización",
    online: "En línea",
    offline: "Fuera de línea",
    lastSync: "Última sincronización",
    pendingSyncs: "{count} cambios pendientes",
    syncNow: "Sincronizar Ahora",
    syncCurrent: "Sincronizar Salón Actual",
    syncAll: "Sincronizar Todos los Salones",
    syncCurrentSuccess: "Salón actual sincronizado con éxito",
    syncCurrentFailed: "Error al sincronizar el salón actual",
    syncAllSuccess: "Todos los salones sincronizados con éxito",
    syncAllPartial: "Algunos salones no se pudieron sincronizar",
    syncError: "Error durante la operación de sincronización",
  },

  sideBar: {
    home: "Inicio",
    about: "Acerca de",
    services: "Servicios",
    profile: "Perfil",
    prospects: "Prospectos",
    salonConfig: "Administración del Salón",
    salonWizard: "Asistente de Salón",
    login: "Iniciar Sesión",
    logout: "Cerrar Sesión",
    contact: "Contacto",
  },

  salonConfig: {
    title: "Configuración del Salón",
    subtitle: "Administra la configuración y personalización de tu salón",
    tabs: {
      general: "General",
      branding: "Imagen de Marca",
      services: "Servicios",
    },
    general: {
      businessInformation: "Información del Negocio",
      salonName: "Nombre del Salón",
      phoneNumber: "Número de Teléfono",
      email: "Correo Electrónico",
      businessHours: "Horarios de Atención",
      openTime: "Hora de Apertura",
      closeTime: "Hora de Cierre",
      days: {
        monday: "Lunes",
        tuesday: "Martes",
        wednesday: "Miércoles",
        thursday: "Jueves",
        friday: "Viernes",
        saturday: "Sábado",
        sunday: "Domingo",
      },
    },
    branding: {
      primaryLogo: "Logo Principal",
      secondaryLogo: "Logo Secundario",
      secondaryLogoDescription:
        "Logo alternativo para usar en diferentes contextos",
      backgroundImage: "Imagen de Fondo",
      logoRequirements:
        "Tamaño recomendado: 500x500 píxeles. Tamaño máximo: 2MB. Formatos: JPG, PNG, SVG.",
      backgroundRequirements:
        "Tamaño recomendado: 1200x400 píxeles. Tamaño máximo: 5MB. Formatos: JPG, PNG.",
      backgroundDescription:
        "Esta imagen aparecerá como fondo en tu sitio web y aplicación.",
      selectLogo: "Seleccionar Logo",
      selectBackground: "Seleccionar Fondo",
      dragOrClick: "Arrastra y suelta tu archivo aquí o haz clic para buscar",
      noLogoSelected: "No se ha seleccionado ningún logo",
      noBackgroundSelected: "No se ha seleccionado ningún fondo",
      uploadLogo: "Subir Logo",
      uploadBackground: "Subir Fondo",
    },
    alerts: {
      saveSuccess: "Cambios guardados exitosamente",
      saveError: "Error al guardar los cambios",
      uploadSuccess: "Archivo subido exitosamente",
      uploadError: "Error al subir el archivo",
    },
  },

  salonSettings: {
    title: "Configuración del Salón",
    subtitle: "Administra la información y preferencias de tu salón",
    saveChanges: "Guardar Cambios",
    currentTheme: "Tema Activo",

    sections: {
      basicInformation: "Información Básica",
      addressInformation: "Información de Dirección",
      themeColors: "Colores del Tema",
      salonLogos: "Logos del Salón",
      quickActions: "Acciones Rápidas",
    },

    fields: {
      publicUrlSlug: "URL Pública",
      salonDescription: "Descripción del Salón",
      streetNumber: "Número",
      neighborhood: "Colonia",
      primaryLogo: "Logo Principal",
      secondaryLogo: "Logo Secundario",
      openingTime: "Hora de Apertura",
      closingTime: "Hora de Cierre",
    },

    hints: {
      publicUrl: "Esta será la URL pública de tu salón",
      salonDescription: "Esto se mostrará en la página pública de tu salón",
    },

    actions: {
      previewTheme: "Vista Previa del Tema",
      viewPublicPage: "Ver Página Pública",
      resetToDefaults: "Restablecer Valores Predeterminados",
      uploadLogo: "Subir Logo",
    },

    validation: {
      phone: "Número de teléfono inválido",
      slug: "Solo se permiten letras minúsculas, números y guiones",
    },

    messages: {
      resetConfirm:
        "¿Estás seguro de que deseas restablecer toda la configuración a los valores predeterminados? Esta acción no se puede deshacer.",
      themePreview: "Vista previa del tema aplicada por 3 segundos",
      logoUploadSuccess: "Logo {type} subido exitosamente",
      logoUploadError: "Error al subir el logo {type}",
      settingsLoaded: "Configuración del salón cargada exitosamente",
      settingsSaved: "Configuración guardada exitosamente",
      settingsLoadError: "Error al cargar la configuración del salón",
      settingsSaveError: "Error al guardar la configuración",
      settingsReset: "Configuración restablecida a valores predeterminados",
    },
  },

  salonWizard: {
    title: "Asistente de Configuración del Salón",
    saveAndContinue: "Guardar y Continuar",
    next: "Siguiente",
    back: "Atrás",
    skip: "Omitir",
    finish: "Finalizar",
    creatingProfile: "Creando tu perfil...",
    salonCreatedSuccess: "¡Salón creado exitosamente!",
    salonCreationError: "Error al crear el salón: {error}",

    // Stepper step names
    steps: {
      businessInfo: "Info del Negocio",
      location: "Ubicación",
      categories: "Categorías",
      services: "Servicios",
      visualIdentity: "Identidad Visual",
      visualStyle: "Estilo Visual",
      photos: "Fotos",
      final: "Final",
    },

    // Alerts
    alerts: {
      saveSuccess: "Cambios guardados exitosamente",
      saveError: "Error al guardar los cambios",
    },

    // Business Info Step
    businessInfo: {
      title: "Info del Negocio",
      subtitle:
        "Cuéntanos sobre tu salón. <br>Queremos conocer lo esencial para crear tu sitio web.",
      businessName: "Nombre de tu Negocio",
      businessNamePlaceholder: "ej. Salón Glamour",
      businessType: "Tipo de Negocio",
      description: "Descripción breve (opcional)",
      descriptionPlaceholder: "Describe tu negocio en pocas palabras...",
      staffCount: "Número de Profesionales",
      selectCount: "Selecciona rango",
      workingHours: "Horarios de Trabajo",
      workingDays: "Días de Servicio",
      types: {
        salonDeBelleza: "Salón de Belleza",
        barberia: "Barbería",
        spa: "Spa",
        estetica: "Estética",
        centroBelleza: "Centro de Belleza",
      },
    },

    // Location Step
    location: {
      title: "Ubicación",
      subtitle: "Ayuda a tus clientes a encontrarte fácilmente",
      country: "País",
      state: "Estado",
      city: "Ciudad",
      street: "Dirección completa",
      streetPlaceholder: "Calle 123, Colonia Centro",
      postalCode: "Código Postal",
      mapLocation: "Ubicación en el Mapa",
      mapPlaceholder: "Coloca el marcador en la ubicación correcta.",
      searchLocation: "Buscar tu ubicación",
      manualEntry: "Escribir manualmente",
      orEnterManually: "O ingresa manualmente",
      selectState: "Seleccionar Estado",
      selectCity: "Seleccionar Ciudad",
      selectPostalCode: "Seleccionar Código Postal",
      useCurrentLocation: "Detectar mi ubicación automáticamente",
      gettingLocation: "Obteniendo tu ubicación...",
      loadingMap: "Cargando mapa...",
      mapError: "Error al cargar el mapa",
      retryMap: "Reintentar",
      countries: {
        mexico: "México",
        usa: "Estados Unidos",
        canada: "Canadá",
      },
    },

    // Visual Style Step
    visualStyle: {
      title: "Estilo Visual",
      subtitle:
        "Dale personalidad a tu sitio. Elige la paleta que mejor represente tu marca. No te preocupes, puedes cambiarla después.",
      preview: "Vista Previa del Sitio Web",
      sampleSalonName: "Nombre de Tu Salón",
      menuHome: "Inicio",
      menuServices: "Servicios",
      menuAbout: "Acerca de",
      menuContact: "Contacto",
      welcomeText: "Bienvenido a Tu Salón",
      taglineText: "Tu destino de belleza",
      bookNowText: "Reservar Ahora",
      themes: {
        elegantMinimalist: {
          name: "Elegante y Minimalista",
          description: "Sofisticado, profesional, atemporal",
        },
        modernYouthful: {
          name: "Moderno y Juvenil",
          description: "Colorido, fresco, dinámico",
        },
        relaxedNatural: {
          name: "Relajado y Natural",
          description: "Orgánico, cálido, acogedor",
        },
        luxuriousBold: {
          name: "Lujoso y Audaz",
          description: "Impactante, premium, con carácter",
        },
        inclusiveVibrant: {
          name: "Inclusivo y Vibrante",
          description: "Diverso, alegre, positivo",
        },
      },
    },

    // Service Categories Step
    serviceCategoriesStep: {
      title: "Categorías de Servicios",
      subtitle: "Define los tipos de servicios que ofreces",
      suggested: "Categorías Sugeridas",
      addCategory: "Agregar Categoría",
      editCategory: "Editar Categoría",
      addNewCategory: "Agregar Nueva Categoría",
      loadDefaults: "Cargar Categorías Predeterminadas",
      categoryName: "Nombre de la Categoría",
      categoryDescription: "Descripción de la Categoría",
      categoryPlaceholder:
        "ej., Servicios de Cabello, Cuidado de Uñas, Cuidado de la Piel",
      customCategoryPlaceholder: "Ej. Colorimetría, Barbería...",
      descriptionPlaceholder: "Breve descripción de esta categoría",
      noCategories: "Aún no se han agregado categorías",
      noCategoriesDescription:
        "Comienza agregando tu primera categoría de servicio",
      deleteConfirm: "¿Eliminar Categoría?",
      selected: "Categorías seleccionadas",
      categories: {
        hairServices: "Servicios de Cabello",
        nailServices: "Servicios de Uñas",
        facialServices: "Servicios Faciales",
        bodyServices: "Servicios Corporales",
        hairCuts: "Cortes de Cabello",
        beardServices: "Servicios de Barba",
        stylingServices: "Servicios de Peinado",
        massageServices: "Servicios de Masaje",
        bodyTreatments: "Tratamientos Corporales",
        facialTreatments: "Tratamientos Faciales",
        wellnessServices: "Servicios de Bienestar",
        skinTreatments: "Tratamientos de Piel",
        bodyContouring: "Contorno Corporal",
        aestheticProcedures: "Procedimientos Estéticos",
        makeupServices: "Servicios de Maquillaje",
      },
    },

    // Detailed Services Step
    detailedServices: {
      title: "Servicios",
      subtitle: "Agrega los servicios específicos que ofreces",
      selectCategory: "Categoría",
      selectCategoryPrompt: "Selecciona categoría",
      servicesIn: "Servicios en",
      serviceName: "Nombre del Servicio",
      serviceNamePlaceholder: "Ej:Corte de cabello",
      duration: "Duración",
      cost: "Precio",
      minutes: "min",
      addService: "Agregar nuevo servicio",
      addAnotherService: "Agregar otro servicio",
      editService: "Editar Servicio",
      deleteConfirm: "¿Estás seguro de que deseas eliminar este servicio?",
      noServicesInCategory: "Aún no has agregado servicios",
      noCategoriesTitle: "No Hay Categorías Disponibles",
      noCategoriesMessage:
        "Por favor agrega categorías de servicios primero antes de agregar servicios detallados.",
      defaultServicesDialog: {
        title: "¿Cargar Servicios Predeterminados?",
        message:
          "Parece que aún no tienes servicios configurados. ¿Te gustaría cargar algunos servicios predeterminados para tus categorías para comenzar?",
        subtitle: "Siempre puedes editar o eliminar estos servicios más tarde.",
        skip: "Omitir",
        loadServices: "Cargar Servicios Predeterminados",
      },
    },

    // Professionals Step
    professionals: {
      title: "Profesionales",
      subtitle: "Agrega información sobre tu equipo",
      addAnotherProfessional: "Agregar otro profesional",
      addProfessional: "Agregar Profesional",
      editProfessional: "Editar Profesional",
      fullName: "Nombre Completo",
      fullNamePlaceholder: "Oscar Rosado",
      role: "Rol o Especialidad",
      rolePlaceholder: "Colorista",
      paymentModality: "Modalidad de Pago",
      paymentModalityPlaceholder: "Comisión",
      phone: "Teléfono",
      phonePlaceholder: "+52 984 169 7256",
      photo: "Foto (Opcional)",
      photoRequirements:
        "Tamaño recomendado: 500x500 píxeles. Tamaño máximo: 2 MB. Formatos soportados: JPG, PNG.",
      personalInfo: "Información Personal",
      services: "Servicios",
      uploadPhoto: "Arrastra, sube o pega imagen",
      noProfessionals: "Aún no se han agregado profesionales",
      noProfessionalsDescription:
        "Agrega miembros de tu equipo para mostrar la experiencia de tu salón",
      deleteConfirm: "¿Estás seguro de que deseas eliminar este profesional?",
    },

    // Hours and Service Step
    hours: {
      title: "Horarios de Apertura",
      subtitle: "Define cuándo está disponible tu salón",
      businessHours: "Horarios de atención:",
      opening: "Apertura",
      closing: "Cierre",
      serviceDays: "Días de servicio:",
      professionalsLabel: "profesional(es)",
    },

    // Visual Identity Step
    visualIdentity: {
      title: "Identidad Visual",
      subtitle: "Personaliza la apariencia de tu salón",
      logo: "Logo del salón",
      logoRequirements: "500x500px, máx. 1MB, JPG/PNG/SVG",
      uploadLogo: "Subir logo",
      banner: "Banner del salón",
      bannerRequirements: "1200x400px, máx. 2MB, JPG/PNG",
      uploadBanner: "Subir banner",
      upload: "Subir",
      bannerDescription:
        "Esto será lo primero que vean tus clientes. Si aún no lo tienes, puedes agregarlo después.",
      noLogo: "No tengo imagen, crear uno después",
      dragOrClick: "Arrastra y suelta tu archivo aquí o haz clic para buscar",
      preview: "Vista Previa",
      bannerPlaceholder: "Tu imagen de banner aparecerá aquí",
      colorPalette: "Paleta de colores:",
      suggestedColors: "Colores sugeridos",
      colorsAutoApply:
        "Estos colores se aplicarán automáticamente a tu sitio web",
      websitePreview: "Vista previa del sitio web:",
      styles: {
        minimalista: {
          name: "Minimalista",
          description: "Limpio y elegante",
        },
        elegante: {
          name: "Elegante",
          description: "Sofisticado y premium",
        },
        juvenil: {
          name: "Juvenil",
          description: "Vibrante y moderno",
        },
        clasico: {
          name: "Clásico",
          description: "Tradicional y atemporal",
        },
      },
    },

    // Gallery Step
    gallery: {
      title: "Galería de Imágenes",
      subtitle: "Muestra tu trabajo con 3-5 fotos (máx. 2MB c/u)",
      addImages: "Agregar imágenes ({count}/5):",
      uploadImages: "Subir imágenes",
      formatRequirements: "JPG, PNG, WEBP - Máx. 2MB por imagen",
      clickOrDrag: "Haz clic o arrastra archivos aquí",
      noImagesYet: "Aún no has agregado imágenes a tu galería",
      imageRequirements: "Requisitos de imágenes:",
      minimum3Images: "Mínimo 3 imágenes",
      maximum5Images: "Máximo 5 imágenes ✓",
      formats: "Formatos: JPG, PNG, WEBP ✓",
      maxSize: "Tamaño máximo: 2MB por imagen ✓",
      needMoreImages:
        "Necesitas agregar al menos {count} imagen{plural} más para continuar.",
      websitePreview: "Vista previa del sitio web",
      previewDescription: "Ve cómo se verán tus fotos en el sitio web",
      hidePreview: "Ocultar vista previa",
      showPreview: "Ver vista previa",
    },

    // Website Preview Component
    preview: {
      title: "Vista Previa de tu Sitio Web",
      subtitle: "Así es como verán tu salón los clientes",
      location: "Ubicación",
      openNow: "Abierto ahora",
      featuredServices: "Servicios Destacados",
      from: "Desde",
      gallery: "Galería",
      galleryPhotoAlt: "Foto de galería",
      morePhotos: "+{count} más",
      bookAppointment: "Agendar Cita",
      contact: "Contactar",
      styleLabel: "Estilo:",
      interactivePreview: "✨ Vista Previa Interactiva",
      previewDescription:
        "Esta es una simulación de cómo se verá tu sitio web con el estilo seleccionado. Los colores, layout y elementos se aplicarán automáticamente según tu elección.",
      responsiveDesign: "• Diseño responsive",
      customColors: "• Colores personalizados",
      logoAndBanner: "• Logo y banner incluidos",
      defaultServices: {
        haircut: "Corte y Peinado",
        coloring: "Colorimetría",
        facialTreatment: "Tratamientos Faciales",
      },
    },

    // Salon Photos Step
    salonPhotos: {
      title: "Fotos del Salón",
      subtitle:
        "Haz que tu salón se vea increíble. Agrega fotos reales de tu espacio. Esto inspira confianza y atrae más clientes.",
      uploadPhotos: "Puedes subir hasta 6 fotos (interior, exterior)",
      photoRequirements:
        "Tamaño máximo: 2 MB. Formatos soportados: JPG, PNG. (290x280 píxeles)",
      selectFromGallery: "Seleccionar 6 imágenes de tu galería",
      upload: "Subir",
      addPhoto: "Agregar Foto",
      addMorePhotos: "Agregar Más Fotos",
      removePhoto: "Eliminar foto",
      photosUploaded: "fotos subidas",
      tipsTitle: "Consejos de Fotografía",
      tip1: "Muestra los mejores ángulos e iluminación de tu salón",
      tip2: "Incluye tomas tanto del interior como del exterior",
      tip3: "Captura tus estaciones de trabajo y área de espera",
      tip4: "Asegúrate de que las fotos estén bien iluminadas y sean de alta calidad",
    },
    // Policies and Payments Step
    policies: {
      title: "Políticas y Pagos",
      subtitle: "Define tus términos de servicio y métodos de pago",
      cancellationPolicy: "Políticas de cancelación",
      cancellationPolicyPlaceholder:
        "Describe tus políticas de cancelación, reservas, etc.",
      suggestedPolicies: "Políticas sugeridas",
      paymentMethodsTitle: "Métodos de pago aceptados",
      termsAndConditions: "Términos y condiciones",
      acceptServiceTerms: "Acepto los términos y condiciones de servicio",
      acceptServiceTermsDescription:
        "Al marcar esta casilla, confirmas que has leído y aceptas nuestros términos de servicio.",
      acceptPrivacyPolicy: "Acepto la política de privacidad",
      acceptPrivacyPolicyDescription:
        "Acepto el procesamiento de mis datos personales según la política de privacidad.",
      dataProtection: "Protección de datos",
      dataProtectionDescription:
        "Tus datos están protegidos y se usan únicamente para el funcionamiento de tu perfil.",
      flexiblePolicies: "Políticas flexibles",
      flexiblePoliciesDescription:
        "Puedes modificar tus políticas en cualquier momento desde tu panel de control.",
      validationError:
        "Debes aceptar los términos y condiciones y la política de privacidad para continuar.",
      defaultCancellationPolicy:
        "Las cancelaciones deben realizarse con al menos 24 horas de anticipación.",
      paymentMethods: {
        cash: "Efectivo",
        card: "Tarjeta de débito/crédito",
        transfer: "Transferencia bancaria",
        digital: "Pagos digitales (PayPal, etc.)",
      },
      suggestedPoliciesList: {
        cancellation24h:
          "Las cancelaciones deben realizarse con al menos 24 horas de anticipación.",
        noPets: "No se permiten mascotas en el establecimiento.",
        punctuality: "El cliente debe llegar puntual a su cita.",
        deposit50:
          "Se requiere depósito del 50% para servicios mayores a $500.",
      },
    },

    // Final Step
    final: {
      title: "Publicar Perfil",
      subtitle: "¡Tu salón está listo para salir en vivo!",
      reviewTitle: "Revisión Final",
      reviewSubtitle: "Revisa toda la información antes de publicar tu perfil",
      congratulations: "¡Felicidades!",
      setupComplete: "La configuración de tu salón está completa",
      publishProfile: "Publicar mi perfil",
      summaryTitle: "Resumen de Configuración",
      previewTitle: "Vista Previa del Sitio Web",
      businessInformation: "Información del Negocio",
      schedule: "Horarios",
      selectedStyle: "Estilo seleccionado:",
      imagesAdded: "imágenes agregadas",
      noPolicies: "No hay políticas definidas",
      readyToPublish: "¡Todo listo para publicar!",
      profileVisibilityMessage:
        "Tu perfil será visible para clientes potenciales inmediatamente después de la publicación.",
      noLocationDefined: "Sin ubicación definida",
      locationUnspecified: "Ubicación no especificada",
      notDefined: "No definido",
      professionals: "profesionales",
      categories: "categorías",
      services: "servicios",
      teamMembers: "miembros del equipo",
      photos: "fotos",
      noAddress: "No se proporcionó dirección",
      bannerPlaceholder: "Tu banner aparecerá aquí",
      featuredServices: "Servicios Destacados",
    },

    // Common elements
    basicInfo: "Información Básica",
    basicInfoDescription:
      "Ingresa la información básica de tu salón. Esta información se mostrará a tus clientes.",
    logo: "Logo",
    logoDescription:
      "Sube el logo de tu salón. Se mostrará en el sitio web, aplicación y materiales de marketing de tu salón.",
    banner: "Banner",
    bannerDescription:
      "Sube una imagen de banner para tu salón. Se mostrará en la parte superior del sitio web y la aplicación de tu salón.",
    themeColors: "Colores del Tema",
    themeColorsDescription:
      "Elige un tema para tu salón. Estos colores se usarán en el sitio web y la aplicación.",
    categories: "Categorías de Servicios",
    services: "Servicios",
    complete: "Completar",
    salonDetails: "Detalles del Salón",
    salonName: "Nombre del Salón",
    address: "Dirección",
    street: "Calle y Número",
    city: "Ciudad",
    state: "Estado/Provincia",
    postalCode: "Código Postal",
    country: "País",
    phoneNumber: "Número de Teléfono",
    email: "Correo Electrónico",
    businessHours: "Horario de Atención",
    open: "Abierto",
    closed: "Cerrado",
    uploadLogo: "Subir Logo",
    uploadBanner: "Subir Banner",
    primaryColor: "Color Primario",
    secondaryColor: "Color Secundario",
    addCategory: "Añadir Categoría",
    addService: "Añadir Servicio",
    categoryName: "Nombre de la Categoría",
    serviceName: "Nombre del Servicio",
    categoryDescription: "Descripción de la Categoría",
    serviceDescription: "Descripción",
    categoryActions: "Acciones de Categoría",
    serviceActions: "Acciones de Servicio",
    serviceDuration: "Duración (minutos)",
    servicePrice: "Precio",
    serviceCategories: "Categorías de Servicios",
    noCategories: "Aún no se han agregado categorías",
    addFirstCategory: "Agregar Primera Categoría",
    deleteConfirmTitle: "Eliminar Categoría",
    deleteConfirmMessage:
      "¿Estás seguro de que deseas eliminar esta categoría? Esta acción no se puede deshacer.",
    useDefaultTitle: "¿Usar Categorías Predeterminadas?",
    useDefaultMessage:
      "¿Te gustaría usar nuestras categorías predeterminadas recomendadas? Puedes personalizarlas después.",
    useDefault: "Usar Categorías Predeterminadas",
    editCategory: "Editar Categoría",
    deleteCategory: "Eliminar Categoría",
    isActive: "Activo",
    selectCategory: "Selecciona una Categoría",
    selectCategoryPrompt:
      "Por favor selecciona una categoría para agregar servicios",
    servicesIn: "Servicios en",
    minutes: "min",
    currency: "Moneda",
    editService: "Editar Servicio",
    deleteService: "Eliminar Servicio",
    noServices: "Aún no se han agregado servicios",
    addFirstService: "Agregar Primer Servicio",
    congratulations: "¡Felicidades!",
    setupComplete: "La configuración de tu salón está completa",
    visitSalon: "Visitar Tu Salón",
    logoRequirements:
      "Tamaño recomendado: 500x500 píxeles. Tamaño máximo: 2MB. Formatos soportados: JPG, PNG, SVG.",
    bannerRequirements:
      "Tamaño recomendado: 1200x400 píxeles. Tamaño máximo: 5MB. Formatos soportados: JPG, PNG.",
    dragOrClick: "Arrastra y suelta tu archivo aquí o haz clic para buscar",
    browseLogo: "Buscar Archivos",
    browseBanner: "Buscar Archivos",
    logoUsage: "Cómo se utilizará tu logo",
    logoUsageWebsite: "Encabezado del Sitio Web",
    logoUsageApp: "Aplicación Móvil",
    logoUsageEmail: "Comunicaciones por Correo",
    logoUsageInvoice: "Facturas y Recibos",
    bannerUsage: "Cómo se utilizará tu banner",
    bannerUsageWebsite: "Encabezado del Sitio Web",
    bannerUsageApp: "Aplicación Móvil",
    bannerUsageSocial: "Redes Sociales",
    bannerUsageEmail: "Marketing por Correo",
    bookNow: "Reservar Ahora",
    salonTagline: "Belleza y Bienestar",
    change: "Cambiar",
    workingHours: "Horarios de Trabajo",
    workingDays: "Días de Servicio",
    servicesOffered: "Servicios Ofrecidos",
    searchPhoto: "Buscar",
    takePhoto: "Tomar foto",
    days: {
      monday: "Lunes",
      tuesday: "Martes",
      wednesday: "Miércoles",
      thursday: "Jueves",
      friday: "Viernes",
      saturday: "Sábado",
      sunday: "Domingo",
    },

    // Theme categories
    themeCategories: {
      professional: "Profesional",
      quirky: "Peculiar",
      modern: "Moderno",
      sophisticated: "Sofisticado",
      natural: "Natural",
    },

    // Theme names
    themeNames: {
      executive: "Ejecutivo",
      corporate: "Corporativo",
      precision: "Precisión",
      playful: "Juguetón",
      vibrant: "Vibrante",
      eclectic: "Ecléctico",
      minimal: "Minimalista",
      urban: "Urbano",
      digital: "Digital",
      luxe: "Lujo",
      elegance: "Elegancia",
      opulence: "Opulencia",
      botanical: "Botánico",
      serene: "Sereno",
      earthy: "Terroso",
    },

    // Validation messages
    validation: {
      businessNameRequired: "El nombre del negocio es obligatorio",
      businessNameTooShort:
        "El nombre del negocio debe tener al menos 2 caracteres",
      streetRequired: "La dirección es obligatoria",
      cityRequired: "La ciudad es obligatoria",
      stateRequired: "El estado es obligatorio",
      categoryNameRequired: "El nombre de la categoría es obligatorio",
      categoryNameExists: "El nombre de la categoría ya existe",
      categoryRequired: "Se requiere al menos una categoría",
      serviceNameRequired: "El nombre del servicio es obligatorio",
      serviceNameExists: "El nombre del servicio ya existe en esta categoría",
      durationRequired: "La duración es obligatoria",
      priceRequired: "El precio debe ser 0 o mayor",
      fullNameRequired: "El nombre completo es obligatorio",
      invalidImageType:
        "Por favor selecciona un archivo de imagen válido (JPG, PNG, SVG)",
      fileTooLarge: "El tamaño del archivo debe ser menor a {size}",
      fileTooLargeGeneric: "El archivo es demasiado grande",
    },
  },

  dashboard: {
    loading: {
      salonData: "Cargando datos del salón...",
    },
    welcome: {
      happeningToday: "Esto es lo que está pasando con {salonName} hoy",
    },

    // Period filters (NEW)
    periods: {
      today: "Hoy",
      week: "Semana",
      month: "Mes",
      custom: "Personalizado",
    },

    // Sales section (NEW)
    sales: {
      total: "Ventas Totales",
      vsYesterday: "vs ayer",
      byProfessional: "Ventas por Profesional",
    },

    // Professional sales (NEW)
    professional: {
      sales: "Ventas por Profesional",
    },

    // Transactions (NEW)
    transactions: {
      types: "Tipos de Transacción",
      cash: "Efectivo",
      card: "Tarjeta",
      transfer: "Transferencia",
    },

    // Appointments (NEW)
    appointments: {
      today: "Citas de Hoy",
      time: "Hora",
      noAppointments: "No hay citas para hoy",
    },

    // Quick actions (NEW)
    actions: {
      newBooking: "Nueva Cita",
      addSale: "Agregar Venta",
    },

    load_failed: "No pudimos cargar tus reservas.",
    retry: "Reintentar",
    status: {
      active: "Activo",
      inactive: "Inactivo",
      acceptingBookings: "Actualmente aceptando reservas",
      salonInactive: "El salón está inactivo",
    },
    stats: {
      activeServices: "Servicios Activos",
      readyToBook: "Listo para reservar",
      serviceCategories: "Categorías de Servicios",
      organized: "Organizado",
      todaysBookings: "Reservas de Hoy",
      revenueToday: "Ingresos de Hoy",
      trendUp: "+15% desde ayer",
      trendDown: "-5% desde ayer",
    },
    bookings: {
      recent: "Reservas Recientes",
      viewAll: "Ver Todas",
      headers: {
        customer: "Cliente",
        service: "Servicio",
        time: "Hora",
        status: "Estado",
        actions: "Acciones",
      },
    },
    quickActions: {
      title: "Acciones Rápidas",
      addService: {
        title: "Agregar Nuevo Servicio",
        subtitle: "Crear una nueva oferta de servicio",
      },
      viewBookings: {
        title: "Ver Todas las Reservas",
        subtitle: "Administrar citas",
      },
      updateInfo: {
        title: "Actualizar Información del Salón",
        subtitle: "Editar detalles del salón",
      },
      viewPublic: {
        title: "Ver Página Pública",
        subtitle: "Ver cómo los clientes ven tu salón",
      },
    },
    salonStatus: {
      title: "Estado del Salón",
      status: "Estado",
      todaysHours: "Horario de Hoy",
      contact: "Contacto",
      manageSettings: "Administrar Configuración",
    },
  },

  // Navegación Admin
  adminNavigation: {
    title: "Panel de Administración",
    subtitle: "Administra las operaciones de tu salón",
    tabs: {
      dashboard: "Inicio",
      clients: "Clientes",
      schedule: "Agenda",
      staff: "Personal",
    },
  },

  // Reservas/Agenda
  bookings: {
    title: "Agenda",
    addButton: "Agregar Cita",
    noAppointments: "No hay citas para este día",
    viewDetails: "Ver Detalles",
  },

  // Gestión de Personal
  staff: {
    title: "Personal",
    loading: "Cargando personal...",
    inviteStaff: "Invitar Personal",
    filters: {
      all: "Todos",
      frequent: "Frecuentes",
    },
    load_failed: "No pudimos cargar tus reservas.",
    retry: "Reintentar",
    status: {
      available: "Disponible",
      busy: "Ocupado",
      off: "Libre",
    },
    emptyState: "No se encontraron miembros del personal",
    invitations: {
      title: "Invitaciones Pendientes",
      pending: "Pendiente",
      sent: "Enviada",
      expired: "Expirada",
      cancel: "Cancelar",
      resend: "Reenviar",
      emptyState: "No hay invitaciones pendientes",
      confirmCancel:
        "¿Estás seguro de que quieres cancelar la invitación para {email}?",
    },
  },

  // Modal de Invitación de Personal
  staffInvitation: {
    emailPlaceholder: "Ingresa el email del colaborador",
    selectRole: "Selecciona un rol",
    personalMessage: "Mensaje Personal",
    messagePlaceholder: "Agrega un mensaje de bienvenida personal (opcional)",
    sending: "Enviando...",
    sendInvitation: "Enviar Invitación",
    sendError: "Error al enviar la invitación. Inténtalo de nuevo.",
  },

  // Roles del Personal
  staffRoles: {
    owner: "Propietario",
    manager: "Gerente",
    receptionist: "Recepcionista",
    cashier: "Cajero",
    professional: "Profesional",
    other: "Otro",
  },

  // Mensajes de Validación
  validation: {
    emailRequired: "El email es requerido",
    emailInvalid: "Por favor ingresa un email válido",
    roleRequired: "Por favor selecciona un rol",
  },

  // Mensajes de Error
  errors: {
    noSalonSelected:
      "No hay salón seleccionado. Por favor selecciona un salón primero.",
    authenticationRequired:
      "Se requiere autenticación. Por favor inicia sesión nuevamente.",
  },

  // Gestión de Clientes
  clients: {
    title: "Clientes",
    addButton: "Agregar Cliente",
    searchPlaceholder: "Buscar por nombre o teléfono...",
    lastVisit: "Última visita",
    filters: {
      all: "Todos",
      frequent: "Frecuentes",
      new: "Nuevos",
      inactive: "Inactivos",
    },
    emptyState: "No se encontraron clientes",
    noResults: "No hay clientes que coincidan con tu búsqueda",
  },

  // Asistente de Reserva
  bookingWizard: {
    title: "Nueva Reserva",
    step: "Paso",
    of: "de",
    close: "Cerrar",
    progress: "Progreso de la reserva",
    submitting: "Creando tu reserva...",
    back: "Atrás",
    continue: "Continuar",
    exitConfirm: "¿Estás seguro que deseas salir? Se perderá tu progreso.",
    exitStay: "Seguir aquí",
    exitLeave: "Salir",
    whatsapp: {
      cta: "Reservar por WhatsApp",
      message: "¡Hola! Quiero reservar {services} para el {day} a las {time}. ¿Me confirmas la cita?",
    },

    // Paso 1: Selección de Servicio
    step1: {
      title: "Elige tu servicio",
      subtitle: "Selecciona el servicio que deseas reservar",
      searchPlaceholder: "Buscar servicios...",
      allCategories: "Todos",
      noServicesFound: "No se encontraron servicios",
      noServicesHint: "Intenta con otra categoría o búsqueda",
      // The catalog states (#47): loading, and honestly-empty — distinct from
      // the search-found-nothing copy above.
      loadingServices: "Cargando servicios...",
      noCatalog: "Este salón aún no publica sus servicios en línea",
      noCatalogHint: "Contacta al salón directamente para reservar",
      noBookable: "Estos servicios se reservan directamente con el salón",
      noBookableHint: "Contacta al salón para elegir el servicio y acordar tu cita.",
      contactSalon: "Contactar al salón",
      backToSalon: "Volver al salón",
      selectedService: "Servicio seleccionado",
      minutes: "minutos",
      servicesSelected: "servicios",
      pickOneHint: "Elige un servicio para continuar",
    },

    // Paso 2: Selección de Profesional
    step2: {
      title: "Elige tu profesional",
      noStaffAvailable: "No hay profesionales disponibles",
      pickNoPreferenceHint: "Selecciona \"Sin preferencia\" para continuar",
      subtitle:
        "Selecciona un profesional o déjanos asignarte el mejor disponible",
      noPreference: "Sin preferencia",
      pickOneHint: "Elige un profesional para continuar",
      noPreferenceDesc:
        "Te asignaremos el mejor profesional disponible para tu horario",
      selectedProfessional: "Profesional seleccionado",
      reviews: "reseñas",
      experience: "experiencia",
      availableSlots: "espacios disponibles",
    },

    // Paso 3: Fecha y Hora
    step3: {
      title: "Selecciona fecha y hora",
      subtitle: "Elige el día y horario que mejor te convenga",
      pickSlotHint: "Elige un día y una hora",
      sessionOne: "{name} · {min} min",
      sessionMany: "{count} servicios · {min} min en total",
      selectDate: "Fecha de la cita",
      selectTime: "Hora disponible",
      morning: "Mañana",
      afternoon: "Tarde",
      evening: "Noche",
      available: "disponibles",
      loadingSlots: "Cargando horarios...",
      selectDateFirst: "Selecciona una fecha para ver horarios disponibles",
      noSlotsAvailable: "No hay horarios disponibles",
      tryAnotherDate: "Intenta con otra fecha",
      // Why-specific empty answers (#43). A closed weekday and an
      // already-closed today are not availability facts; rendering them as
      // "no hay horarios" made honest states read like a broken site.
      closedThisWeekday: "El salón no abre los {weekday}",
      closedForToday: "El salón ya cerró por hoy",
      chooseAnotherDay: "Elige otro día",
      dayFull: "No quedan horarios libres para este día",
      closedDay: "Cerrado",
      // The fetch itself failed (network / edge down). Distinct from a day
      // that is simply full: telling someone "no hay horarios" when we never
      // managed to ask sends them away from a salon that may be wide open.
      slotsUnavailable: "No pudimos cargar los horarios",
      slotsRetry: "Revisa tu conexión o intenta de nuevo en un momento",
      timezoneNotice:
        "Tu zona horaria es diferente a la de {salon}. Los horarios que ves son la hora local del salón.",
      selectedAppointment: "Cita seleccionada",
    },

    // Paso 4: Confirmación
    step4: {
      title: "Confirma tu reserva",
      privacyNotice: "Tu información está protegida y nunca será compartida con terceros",
      servicesSummary: "{count} servicios · {min} min en total",
      completeRequired: "Por favor completa todos los campos requeridos (*)",
      verifyEmailToContinue: "Verifica tu correo para continuar.",
      verifyOrClearEmail: "Verifica tu correo para continuar, o bórralo si no deseas registrarlo.",
      nameRequired: "El nombre es requerido",
      emailRequired: "El correo es requerido",
      emailInvalid: "Correo electrónico inválido",
      subtitle:
        "Revisa los detalles de tu cita y completa tu información para confirmar tu reserva",
      contactInfo: "Información de contacto",
      fullName: "Nombre completo",
      fullNamePlaceholder: "Tu nombre",
      email: "Correo electrónico",
      emailPlaceholder: "ejemplo{'@'}correo.com",
      phone: "Teléfono",
      phonePlaceholder: "+52 55 1234 5678",
      verifyPhone: "Verificar número de celular",
      verifyPhoneHelp: "Deberás enviarnos un mensaje por WhatsApp para validar tu teléfono.",
      returningVerified: "Reservando con tus datos ya verificados",
      verifyOtherContact: "¿Deseas verificar otro correo y número?",
      verifyOtherPhone: "¿Quieres verificar otro número telefónico?",
      checkingVerified: "Comprobando tus datos verificados…",
      verifyOtherEmail: "¿Deseas verificar otro correo?",
      termsAcceptLabel: "Declaro ser mayor de edad y acepto los",
      termsAcceptLink: "Términos y Condiciones y el Aviso de Privacidad",
      termsThenYourData: "Completa tus datos para continuar:",
      termsRequiredNudge: "Debes aceptar los términos y condiciones para completar tu reserva",
      termsAcceptedOn: "Aceptaste los Términos y Condiciones el {date}.",
      termsSeeAccepted: "Ver el documento que aceptaste",
      confirmFailed: "No pudimos crear tu reserva. Es posible que el horario ya no esté disponible; elige otro e intenta de nuevo.",
      confirmRateLimited: "Demasiados intentos por ahora. Espera unos minutos e intenta de nuevo.",
      confirmTransient: "No pudimos completar tu reserva. Intenta de nuevo en un momento.",
      confirmExpired: "Tu reserva expiró por tiempo de espera. La preparamos de nuevo: revisa el horario y confirma otra vez.",
      confirmExpiredRetry: "Tu reserva expiró por tiempo de espera y no pudimos prepararla de nuevo ahora. Espera un momento e intenta otra vez.",
      draftRateLimited: "Has hecho demasiados intentos. Espera unos minutos e intenta de nuevo.",
      draftUnavailable: "No pudimos preparar tu reserva. Intenta de nuevo en un momento.",
      phoneVerified: "Teléfono verificado",
      verifyEmail: "Verificar correo",
      emailVerified: "Correo verificado",
      emailCodeSent: "Te enviamos un código de 6 dígitos a tu correo. Ingrésalo aquí:",
      emailCodePlaceholder: "000000",
      resendEmailCode: "Reenviar código",
      emailCodeWrong: "Código incorrecto. Revisa tu correo e intenta de nuevo.",
      emailCodeExpired: "El código venció. Pide uno nuevo con \"Reenviar código\".",
      emailTooManyAttempts: "Demasiados intentos. Espera unos minutos e intenta de nuevo.",
      emailTooManySends: "Ya enviamos varios códigos. Revisa tu bandeja de spam o espera unos minutos.",
      emailSendFailed: "No pudimos enviar el código. Intenta de nuevo en un momento.",
      specialPreferences: "Preferencias especiales (opcional)",
      notesPlaceholder:
        "Ejemplo: Prefiero música relajante, tengo alergias a ciertos productos, necesito estacionamiento...",
      specialPreferencesHint:
        "Comparte cualquier detalle que nos ayude a brindarte una mejor experiencia",
      additionalNotes: "Notas adicionales (opcional)",
      paymentMethod: "Método de pago",
      cardPayment: "Tarjeta",
      cardPaymentDesc: "Pagar ahora",
      cashPayment: "Efectivo",
      cashPaymentDesc: "Pagar en salón",
      securityBadge: "Pago seguro procesado con cifrado de última generación",
      bookingSummary: "Resumen de reserva",
      service: "Servicio",
      professional: "Profesional",
      date: "Fecha",
      time: "Hora",
      duration: "min",
      subtotal: "Subtotal",
      tax: "IVA (16%)",
      total: "Total",
      // The salon-conditions card renders the OWNER-written policy (#50);
      // no default claim exists on purpose — absent policy, absent card.
      salonConditions: "Condiciones del salón",
      confirmBooking: "Confirmar reserva",
      confirmingBooking: "Confirmando reserva...",
    },

    // Pantalla de Éxito
    success: {
      title: "¡Reserva registrada!",
      message:
        "Tu cita ha sido agendada exitosamente. Recibirás un correo de confirmación con todos los detalles.",
      bookingIdLabel: "ID Reserva",
      messageNoEmail:
        "Tu reserva quedó registrada y el salón la confirmará pronto. Puedes consultar el estado de tu reserva aquí mismo.",
      bookingDetails: "Detalles de la reserva",
      service: "Servicio",
      professional: "Profesional",
      date: "Fecha",
      time: "Hora",
      returnHome: "Volver al inicio",
      addToCalendar: "Agregar al calendario",
    },
  },

  // Vistas públicas del salón
  publicSalon: {
    gallery: {
      // Neutral editorial fallback for the gallery heading — the salon's own
      // galleryTitle (gtt, #50) wins when set.
      defaultTitle: "El arte de sentirte increíble",
    },
    team: {
      // Neutral fallback for the team heading — the salon's own teamTitle
      // (tmt, #51) wins when set; the section itself is opt-in via vst.
      defaultTitle: "Manos expertas",
    },
    // A service's own photos (gal, #153), in booking and on its home card.
    serviceGallery: {
      label: "Fotos de {name}",
      photoAlt: "Foto {n} de {name}",
    },
    // Home
    home: {
      verified: "Verificado",
      reviews: "reseñas",
      reviewsCount: "1 reseña | {count} reseñas",
      bookNow: "Reservar ahora",
      // Header nav + the burger's site menu (#127).
      nav: {
        services: "Servicios",
        gallery: "Galería",
        team: "Equipo",
        location: "Ubicación",
        menu: "Menú",
        close: "Cerrar",
        whatsapp: "Escríbenos",
        language: "Idioma",
      },
      // Home sections, states and weekday names (#128) — every literal the
      // page used to hardcode. Copy stays neutral Spanish.
      status: {
        openNow: "Abierto ahora",
        open: "Abierto",
        until: "hasta {time}",
        todayUntil: "Hoy hasta las {time}",
        // Un turno que termina después de la medianoche cierra MAÑANA (#43):
        // a las 23:00 del lunes, "Hoy hasta las 2:00 AM" nombra una hora que
        // ya pasó.
        tomorrowUntil: "Mañana hasta las {time}",
        closed: "Cerrado",
        // Un turno que cierra más tarde de la medianoche (#43): "9:00 PM -
        // 2:00 AM" a secas se lee como un error de tipeo.
        closesNextDay: "{open} - {close} (día siguiente)",
      },
      days: {
        monday: "Lunes",
        tuesday: "Martes",
        wednesday: "Miércoles",
        thursday: "Jueves",
        friday: "Viernes",
        saturday: "Sábado",
        sunday: "Domingo",
      },
      sections: {
        services: {
          eyebrow: "Servicios",
          title: "Reserva tu momento",
          subtitle: "Elige un servicio y agenda tu cita en línea en menos de un minuto.",
          all: "Todos",
          ask: "Consultar",
          book: "Reservar",
        },
        gallery: {
          eyebrow: "Galería",
          cta: "Reserva tu look",
        },
        team: {
          eyebrow: "Equipo",
        },
        location: {
          eyebrow: "Visítanos",
          title: "Horarios y ubicación",
          mapTitle: "Mapa de ubicación",
          directions: "Cómo llegar",
        },
        closing: {
          // Neutral on purpose: the salon's customers are not one gender.
          title: "¿Agendamos tu próxima cita?",
          bookingLead: "Resérvala en segundos, sin llamadas ni esperas.",
          whatsappLead: "Escríbenos por WhatsApp y coordinamos tu cita.",
        },
      },
      footer: {
        website: "Sitio web",
      },
      tabs: {
        about: "Acerca de",
        services: "Servicios",
        team: "Equipo",
        reviews: "Reseñas",
      },
      description: "Descripción",
      characteristics: "Características",
      gallery: "Galería",
      noPhotos: "No hay fotos disponibles",
      discount: "Descuento",
      popular: "Popular",
      book: "Reservar",
      noServices: "No hay servicios disponibles en este momento",
      viewAvailability: "Ver disponibilidad",
      noTeam: "No hay información del equipo disponible en este momento",
      overallRating: "Calificación general",
      ratingBreakdown: "Desglose de calificaciones",
      noReviews: "No hay reseñas disponibles en este momento",
      lastVisit: "Última visita",
    },

    // Services
    services: {
      title: "Nuestros Servicios",
      subtitle:
        "Descubre nuestra amplia gama de servicios profesionales de belleza y bienestar",
      allServices: "Todos los Servicios",
      popular: "Popular",
      book: "Reservar",
      min: "min",
      noServices: "No se encontraron servicios",
      noServicesHint:
        "Intenta seleccionar una categoría diferente o vuelve más tarde.",
      schedule: "Horarios",
      contact: "Contacto",
      location: "Ubicación",
      getDirections: "Cómo llegar",
      closed: "Cerrado",
      // Misma fila de horarios que en Home, mismo turno de madrugada (#43).
      closesNextDay: "{open} - {close} (día siguiente)",
      mapNotAvailable: "Mapa no disponible",
    },

    // Layout (Footer & Header)
    layout: {
      back: "Volver",
      share: "Compartir",
      favorite: "Favorito",
      // SalonLayout asks for these six; only the three above existed, so the
      // template rendered the raw key. The `$t(...) || 'fallback'` idiom in
      // that file never fired: vue-i18n returns the KEY when a message is
      // missing, and a key is truthy. Visible proof was
      // "publicSalon.layout.skipToContent" printed on every salon page.
      removeFavorite: "Quitar de favoritos",
      skipToContent: "Saltar al contenido principal",
      loading: "Cargando datos del salón",
      errorTitle: "No pudimos cargar el salón",
      errorMessage: "Revisa tu conexión e inténtalo de nuevo.",
      retry: "Intentar de nuevo",
      disabledTitle: "Este salón está temporalmente deshabilitado",
      disabledMessage: "La información en línea de este salón no está disponible por el momento.",
      disabledBack: "Volver al inicio",
      newsletter: {
        title: "Suscríbete a nuestro newsletter",
        placeholder: "ejemplo{'@'}correo.com",
        subscribe: "Suscribirse",
        thankYou: "¡Gracias por suscribirte!",
      },
      footer: {
        description:
          "Descubre y reserva los mejores servicios de belleza cerca de ti. Profesionales certificados, precios transparentes y reservas instantáneas.",
        discover: "Descubrir",
        nearSalons: "Salones cercanos",
        topProfessionals: "Top profesionales",
        popularServices: "Servicios populares",
        specialOffers: "Ofertas especiales",
        forYou: "Para ti",
        myBookings: "Mis reservas",
        favorites: "Favoritos",
        history: "Historial",
        paymentMethods: "Métodos de pago",
        support: "Soporte",
        helpCenter: "Centro de ayuda",
        terms: "Términos y condiciones",
        privacy: "Política de privacidad",
        contact: "Contacto",
        forBusiness: "Para negocios",
        registerSalon: "Registra tu salón",
        dashboard: "Panel de control",
        resources: "Recursos",
        api: "API",
        email: "Email",
        phone: "Teléfono",
        office: "Oficina",
        officeLocation: "Ciudad de México, MX",
        copyright: "Todos los derechos reservados.",
        privacyPolicy: "Privacidad",
        termsOfService: "Términos",
        cookies: "Cookies",
      },
      shareLink: {
        title: "Comparte este salón",
        copied: "¡Link copiado al portapapeles!",
      },
    },
  },
  // Customer menu — "Mis reservas" (#106)
  customerMenu: {
    title: "Mis reservas",
    open_menu: "Mi cuenta",
    close: "Cerrar",
    verified: "Verificado",
    profile: "Perfil",
    phone_label: "Teléfono",
    email_label: "Correo electrónico",
    unverified: "Sin verificar",
    verify_cta: "Verificar",
    loading: "Cargando tus reservas…",
    empty: "Aún no tienes reservas próximas.",
    active: "Próximas",
    other_salons: "Reservas en otros salones",
    history: "Historial",
    history_loading: "Leyendo reservas pasadas…",
    history_empty: "No tienes reservas pasadas.",
    name_label: "Nombre",
    name_edit: "Editar nombre",
    name_save: "Guardar",
    name_cancel: "Cancelar",
    vf_preparing: "Preparando la verificación…",
    vf_open_whatsapp: "Abrir WhatsApp",
    vf_waiting: "Esperando la verificación…",
    vf_send_code: "Enviar código",
    vf_code_label: "Código",
    vf_check_code: "Confirmar",
    vf_done: "¡Verificado!",
    vf_failed: "No pudimos iniciar la verificación. Inténtalo de nuevo.",
    vf_rate_limited: "Demasiados intentos. Espera unos minutos e inténtalo de nuevo.",
    vf_bad_code: "El código no es correcto.",
    vf_attempts_left: "intentos restantes: {n}",
    vf_code_expired: "El código venció. Pide uno nuevo.",
    vf_attempts_exhausted: "Demasiados intentos con este código. Pide uno nuevo.",
    vf_resend: "Cambiar correo / reenviar",
    vf_send_limit: "Alcanzaste el límite de envíos. Inténtalo más tarde.",
    vf_reverify_cta: "Verificar ahora",
    wipe_link: "Borrar datos en este dispositivo",
    wipe_confirm:
      "Se borrarán todos los datos guardados en este dispositivo (sesión, nombre y preferencias). ¿Deseas continuar?",
    wipe_cta: "Borrar",
    reverify: "Por seguridad, confirma tu identidad de nuevo para ver tus reservas.",
    write_salon: "Escribir al salón",
    wa_message: "Hola, te escribo por mi reserva del {when} ({services}).",
    wa_booking_fallback: "reserva",
    notification_now: "ahora",
    notify_confirmed_title: "¡Reserva confirmada!",
    notify_confirmed_body: "{salon} confirmó tu reserva del {when}.",
    notify_cancelled_title: "Reserva cancelada",
    notify_cancelled_body: "{salon} canceló tu reserva del {when}. Toca para reservar otro horario.",
    load_failed: "No pudimos cargar tus reservas.",
    retry: "Reintentar",
    status: {
      pending: "Pendiente",
      confirmed: "Confirmada",
      completed: "Completada",
      cancelled: "Cancelada",
      no_show: "No asistió",
    },
  },
};
